// removed by extract-text-webpack-plugin
module.exports = {"root":"drones--root--3T4r_DS3 home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","label":"drones--label--1EauBFTe","input":"drones--input--3yeOsfzl"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/drones/styles.css
// module id = ./views/refunds/drones/styles.css
// module chunks = 0